// @flow
import { _get, _post } from "./methods";

export default {
  tate: {
    listMappings: (params: any) => _get("/admin/exhibitions/tate/mappings", params),
    saveMapping: (params: any) => _post("/admin/exhibitions/tate/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/tate/import_snapshot", params)
  },
  national_gallery: {
    listMappings: (params: any) =>
      _get("/admin/exhibitions/national_gallery/mappings", params),
    saveMapping: (params: any) =>
      _post("/admin/exhibitions/national_gallery/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/national_gallery/import_snapshot", params)
  }
};
